import { formatConfigUnmarshaller as HeaderAdConfigUnmarshaller } from '../header-ad';

export const formatConfigUnmarshaller = {
  ...HeaderAdConfigUnmarshaller
};
